// React
import { useState, useEffect, useCallback } from 'react';

// Amplify UI
import '@aws-amplify/ui-react/styles.css';
import {
    Input,
    Link,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    SelectField,
    Button,
} from '@aws-amplify/ui-react';
import { callBackend } from './api.js';

export default function ListAll({
    showHistoryFn
}) {
    const [bodyParts, setBodyParts] = useState([]);
    const [exercises, setExercises] = useState({});
    const [selectedBodyPart, setSelectedBodyPart] = useState("");
    const [isRefreshing, setIsRefreshing] = useState(false);
    const [exerciseIndex, setExerciseIndex] = useState(-2);
    const [adding, setAdding] = useState(false);
    
    const refreshExerciseList = useCallback(async () => {
        setIsRefreshing(true); 
        const myInit = {
            get_body_parts: "All"
        };

        try {
            const apiResult = await callBackend("workouts", "GET", myInit);
            
            setBodyParts(apiResult["body_parts"]);
            setExercises(apiResult["exercises"]);
        } catch (e) {
            setBodyParts([]);
            setExercises({});
            alert(`Error refreshing workouts: ${e}`);
        }
        setIsRefreshing(false);
    }, []);

    useEffect(() => {
        refreshExerciseList();
    }, [refreshExerciseList]);

    function refreshBodyPart(part) {
        setSelectedBodyPart(part);
    }

    function openDropdown(index) {
        setExerciseIndex(index);
    }

    function openAdding() {
        setAdding(true);
    }

    async function addToPreferred(day, exercise, counter) {
        setIsRefreshing(true); 
        const myInit = {
            body: {
                action: "addPreferred",
                day: day,
                exercise: exercise
            },
        };

        try {
            await callBackend("workouts", "PUT", myInit);
            setExerciseIndex(-1);
            console.log('in adding ' + day +":"+ exercise+":"+counter);
            setIsRefreshing(false);
        } catch (e) {
            setIsRefreshing(false);
            alert(`Error refreshing workouts: ${e}`);
        }
    }

    async function addExercise(exercise, setting) {
        setIsRefreshing(true); 
        console.log('in adding exercise:'+ exercise);
        const myInit = {
            body: {
                action: "addExercise",
                bodyPart: selectedBodyPart,
                exercise: exercise,
                setting: setting
            },
        };

        try {
            await callBackend("workouts", "PUT", myInit);
            
            setAdding(false);
            refreshExerciseList();
            refreshBodyPart(selectedBodyPart);
            setIsRefreshing(false);
        } catch (e) {
            setIsRefreshing(false);
            alert(`Error refreshing workouts: ${e}`);
        }
    }
    
    // Return table rows of exercises
    function ExerciseRows() {
        if (selectedBodyPart in exercises) {
            return exercises[selectedBodyPart].map((i, counter) => {
                return (
                    <TableRow key={i}>
                        <TableCell>
                            <Link 
                                onClick={(e) => showHistoryFn(i)}
                            >
                                {i}   
                            </Link>
                        </TableCell>
                        <TableCell>
                            <Link 
                                onClick={(e) => openDropdown(counter)}
                            >
                                <img 
                                    src="/images/plus.png"
                                    alt="Add to preferred" 
                                    height="30px" width="30px"
                                />
                            </Link>
                            { (exerciseIndex===counter) ? 
                                <SelectField 
                                    label="Day"
                                    onChange={(e) => addToPreferred(e.target.value, i, counter)}
                                    >
                                    <option value="-2">-- Please Select</option>
                                    <option value="-1">Today</option>
                                    <option value="0">Sunday</option>
                                    <option value="1">Monday</option>
                                    <option value="2">Tuesday</option>
                                    <option value="3">Wednesday</option>
                                    <option value="4">Thursday</option>
                                    <option value="5">Friday</option>
                                    <option value="6">Saturday</option>
                                </SelectField>
                            : "" }
                            
                        </TableCell>
                    </TableRow>
                );
            });
        } else {
            return "";
        }
    }

    return (
        <Table highlightOnHover={true} variation="striped">
            <TableHead>
                <TableRow>
                    <TableCell as="th">
                        <SelectField 
                            label="Body Part"
                            value={selectedBodyPart}
                            disabled={isRefreshing}
                            onChange={(e) => refreshBodyPart(e.target.value)}
                        >
                            <option value="-1" key="-1">--Please Select--</option>
                            { 
                                bodyParts.map((i) => {
                                    return (
                                        <option value={i} key={i}>{i}</option>
                                    );
                                })
                            }
                        </SelectField>
                    </TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                <ExerciseRows />
                { (selectedBodyPart === "" || adding) ? "" : 
                    <TableRow>
                        <TableCell colSpan="2" textAlign="center">
                            <Button onClick={() => openAdding()} >Add Exercise</Button>
                        </TableCell>
                    </TableRow>
                }
                { (adding) ?
                    <TableRow>
                        <TableCell colSpan={2} textAlign='center'>
                            <Input id="exercise" placeholder="Exercise" /><br />
                            <Input id="setting" placeholder="Setting" /><br />
                            <Button onClick={() => addExercise(document.getElementById("exercise").value, document.getElementById("setting").value)} >
                                Add
                            </Button>
                        </TableCell>
                    </TableRow>
                : "" }
            </TableBody>
            
        </Table>
        
    );
}
